import {getEnv} from '../../../common/env/env';
import {LogoutHandlerParam} from '../../../common/shared/login-pageweb/LogoutHandlerParam.interface';
import {SESSION_STORAGE_WELCOME_POPUP} from '../../../popup/constants';
import {SESSION_STORAGE_INVEN_SORT_OPTION_INFO} from '../../inven/[invenType]/constant';

export async function logoutPageweb(param: LogoutHandlerParam) {
  // 웰컴팝업을 닫기 눌렀어도 로그아웃 시 다시 볼 수 있도록 세션 스토리지를 초기화 합니다.
  window.sessionStorage.removeItem(SESSION_STORAGE_WELCOME_POPUP);
  // 로그아웃 시 보관함 정렬 정보를 초기화합니다.
  window.sessionStorage.removeItem(SESSION_STORAGE_INVEN_SORT_OPTION_INFO);
  return getEnv().useSandboxKakao
    ? (
        await import(
          '../../../common/shared/login-pageweb/logoutSandbox.function'
        )
      ).logoutSandbox(param)
    : (
        await import('../../../common/shared/login-pageweb/logout.function')
      ).logout(param);
}
